import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Check } from "lucide-react";

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/enquiries").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markHandled = async (id) => {
    try {
      await api.patch(`/enquiries/${id}`, { status: "handled" });
      toast.success("marked as handled.");
      load();
    } catch {
      toast.error("update failed.");
    }
  };

  return (
    <AdminLayout>
      <div data-testid="admin-enquiries" className="max-w-5xl">
        <span className="editorial-label">customers · enquiries</span>
        <h1 className="font-serif text-5xl lowercase text-charcoal mt-3 mb-2">conversations to be had.</h1>
        <p className="text-espresso max-w-2xl mb-10">every “enquire to acquire” submission lands here for a personal reply.</p>

        {items.length === 0 ? (
          <div className="border border-taupe/40 p-16 text-center">
            <Mail className="w-8 h-8 text-taupe mx-auto mb-4" />
            <p className="font-serif text-2xl lowercase text-charcoal">no enquiries yet.</p>
            <p className="editorial-label mt-3">beautiful things deserve another story.</p>
          </div>
        ) : (
          <div className="space-y-5">
            {items.map((e, i) => (
              <div key={e.id} data-testid={`enq-row-${i}`} className={`bg-linen border ${e.status === "handled" ? "border-taupe/30 opacity-70" : "border-brass/60"} p-6`}>
                <div className="flex items-start justify-between gap-6">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <span className={`text-[0.65rem] tracking-widest uppercase px-2 py-0.5 ${e.status === "handled" ? "bg-taupe/30 text-charcoal" : "bg-brass text-ivory"}`}>{e.status}</span>
                      <p className="text-xs text-taupe">{new Date(e.created_at).toLocaleString()}</p>
                    </div>
                    <h3 className="font-serif text-2xl lowercase text-charcoal">{e.name}</h3>
                    <p className="text-xs text-espresso mt-1">{e.email} {e.phone ? `· ${e.phone}` : ""}</p>
                    {e.item_title && <p className="editorial-label mt-3">interested in · {e.item_title.toLowerCase()}</p>}
                    <p className="text-sm text-charcoal mt-4 whitespace-pre-wrap leading-relaxed">{e.message}</p>
                  </div>
                  {e.status !== "handled" && (
                    <button onClick={() => markHandled(e.id)} data-testid={`mark-handled-${i}`} className="flex items-center gap-2 border border-taupe hover:border-brass px-4 py-2 text-[0.65rem] tracking-[0.25em] uppercase">
                      <Check className="w-3 h-3" /> mark handled
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
